import { Link } from 'react-router-dom'
import Navbar from '../components/Navbar'
import SEO from '../components/SEO'

export default function ContestsPage() {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)' }}>
      <SEO title="Writing Contests" description="Enter writing contests and competitions on Verse. Win recognition and connect with fellow writers." />
      <Navbar />
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 'calc(100vh - 64px)',
        padding: '40px 24px',
        textAlign: 'center',
      }}>
        <div style={{ fontSize: '3rem', marginBottom: 20 }}>🏆</div>
        <h1 style={{ fontSize: '2rem', fontWeight: 700, color: 'var(--text)', margin: '0 0 12px' }}>
          Contests — Coming Soon
        </h1>
        <p style={{ fontSize: '1rem', color: 'var(--text-muted)', maxWidth: 480, lineHeight: 1.7, margin: '0 0 32px' }}>
          Writing contests are on their way. Check back soon for community challenges,
          themed prompts, and featured prizes.
        </p>
        <Link to="/" className="btn btn-primary">Back to home</Link>
      </div>
    </div>
  )
}
